/**
 * Con links internos
 */
import React, { useEffect, useState, Fragment } from 'react';
import CustomCarousel from '../Antd/Carousel';
import { Services } from './services';
import './style.scss';

const canOpen = (link) => typeof link === 'string' && link.trim() && !['null', 'undefined'].includes(link.trim().toLowerCase());

export default function SlidersInternal(props) {
	const [sliders, setSliders] = useState([]);
	const [isLoading, setLoading] = useState(true);

	useEffect(() => {
		new Services().getTempplate({ template: props.template, location: props.location }).then((response) => {
			console.log('sliders', response);
			if (response.length > 0) {
				setSliders([...response]);
				setLoading(false);
			}
		});
	}, [props.template, props.location]);

	if (isLoading) {
		return Fragment;
	}

	return (
		<CustomCarousel autoplay={true} className={'slider-internal'}>
			{sliders.map((item, index) => (
				<div key={index} onClick={canOpen(item.link) ? () => window.open(item.link) : undefined}>
					<img src={item.image} alt={item.template} />
				</div>
			))}
		</CustomCarousel>
	);
}
